export type OnboardingProfileFieldName =
  | 'username'
  | 'warRoomAvatar'
  | 'warRoomAvatarUrl'
  | 'warRoomPosition'
  | 'warRoomYearsOfExperience'
  | 'warRoomCustomExpectation'
  | 'warRoomSalesRoles'
  | 'warRoomTopics'
  | 'warRoomExpectations'
  | 'productTypes'
  | 'warRoomIndustries';

export const formFieldNames: Record<string, OnboardingProfileFieldName> = Object.freeze({
  USERNAME: 'username',
  WAR_ROOM_AVATAR: 'warRoomAvatar',
  WAR_ROOM_AVATAR_URL: 'warRoomAvatarUrl',
  WAR_ROOM_POSITION: 'warRoomPosition',
  WAR_ROOM_YEARS_OF_EXPERIENCE: 'warRoomYearsOfExperience',
  WAR_ROOM_CUSTOM_EXPECTATION: 'warRoomCustomExpectation',
  WAR_ROOM_SALES_ROLES: 'warRoomSalesRoles',
  WAR_ROOM_TOPICS: 'warRoomTopics',
  WAR_ROOM_EXPECTATIONS: 'warRoomExpectations',
  PRODUCT_TYPES: 'productTypes',
  WAR_ROOM_INDUSTRIES: 'warRoomIndustries',
});

export type JobSearchStatusKey = 'actively_looking' | 'passively_looking' | 'not_interested';

export const jobSearchStatusKeys: Record<string, JobSearchStatusKey> = Object.freeze({
  ACTIVELY_LOOKING: 'actively_looking',
  PASSIVELY_LOOKING: 'passively_looking',
  NOT_INTERESTED: 'not_interested',
});

export const jobSearchStatusLabels: Record<string, string> = Object.freeze({
  [jobSearchStatusKeys.ACTIVELY_LOOKING]: 'Actively Looking',
  [jobSearchStatusKeys.PASSIVELY_LOOKING]: 'Open to Offers',
  [jobSearchStatusKeys.NOT_INTERESTED]: 'Not interested in any offers',
});

export const ONBOARDING_TOOLTIP_NAME: string = 'war_room:onboarding-v2';
export const ONBOARDING_STEP_COUNT: number = 5;
